/**
 * responsive table
 */
export function table_responsive(){
	$("table").wrap("<div class='table_responsive'>");
}
